import { HttpClient } from '@adapters/HttpClient';
import type { Option, Store } from './types';
import globalCache from '@shared/lib/GlobalCache';

interface StoresFilters {
  tenantChildId?: number;
}

export class StoresApiAdapter {
  constructor(private httpClient: HttpClient) {}

  async getAll(filters: StoresFilters = {}): Promise<Option[]> {
    const cacheKey = filters.tenantChildId
      ? `stores-${filters.tenantChildId}`
      : 'stores-all';
    return globalCache.getOrSet(cacheKey, async () => {
      const params: any = {
        order_by: 'id',
        order_direction: 'asc',
        page: '1',
        per_page: '100',
      };

      // 🎯 Usar advanced_filters con team_id cuando hay tenantChildId
      if (filters.tenantChildId) {
        params['advanced_filters[filters][0][column]'] = 'team_id';
        params['advanced_filters[filters][0][operator]'] = 'in';
        params['advanced_filters[filters][0][value][0]'] = String(filters.tenantChildId);
        params['advanced_filters[logic]'] = 'AND';
      }

      const raw = await this.httpClient.get<any>('/shops', params);
      const list = Array.isArray(raw) ? raw : (raw.data ?? []);
      return list.map((s: any) => ({
        id: String(s.id),
        name: s.name,
      }));
    });
  }

  async getStores(filters: StoresFilters = {}): Promise<Store[]> {
    const cacheKey = filters.tenantChildId
      ? `stores-full-${filters.tenantChildId}`
      : 'stores-full-all';
    return globalCache.getOrSet(cacheKey, async () => {
      const params: any = {
        order_by: 'id',
        order_direction: 'asc',
        page: '1',
        per_page: '100',
      };

      // 🎯 Usar advanced_filters con team_id cuando hay tenantChildId
      if (filters.tenantChildId) {
        params['advanced_filters[filters][0][column]'] = 'team_id';
        params['advanced_filters[filters][0][operator]'] = 'in';
        params['advanced_filters[filters][0][value][0]'] = String(filters.tenantChildId);
        params['advanced_filters[logic]'] = 'AND';
      }

      const raw = await this.httpClient.get<any>('/shops', params);
      const list = Array.isArray(raw) ? raw : (raw.data ?? []);
      return list.map((s: any) => ({
        id: s.id,
        name: s.name,
        code: s.code || s.store_code || `STORE-${s.id}`,
        address: s.address,
        phone: s.phone,
        email: s.email,
      }));
    });
  }
}
